import { useRef, useState, useCallback, useEffect } from "react";
import { GetCourseDetails, GetLearningUrl, LearningCourse } from "../../handler/coursehandler";

const packageJson = require('../../../package.json');
interface InnerBannerProps {
    courseId: number;
}

const Learning: React.FC<InnerBannerProps> = ({ courseId }) => {
    const [videoShow, setVideoShow] = useState("");
    const playerRef = useRef<HTMLVideoElement | null>(null);
    const [isVideoPlay, setIsVideoPlay] = useState(true);
    const [userInformationId, setUserInformationId] = useState(0);
    const [selectedCourse, setSelectedCourse] = useState(
        {
            "courseVideoId": 1,
            "courseVideoName": "",
            "courseServerName": "BodyLanguage_Chapter_1",
            "videoDurationInSeconds": 0,
            "currentVideoDurationInSeconds": 0,
            "videoPercentage": 0
        },
    );
    const [courseLearning, setCourseLearning] = useState(
        {
            "courseId": 0,
            "courseName": "",
            "serverName": "",
            "courseDescription": "",
            "packageId": 0,
            "coursePrice": 0,
            "percentage": 0,
            "currentVideoId": 0,
            "courseVideos": [
                {
                    "courseVideoId": 0,
                    "courseVideoName": "",
                    "courseServerName": "",
                    "totalVideoDurationInSeconds": 0,
                    "currentVideoDurationInSeconds": 0,
                    "courseId": 0,
                    "videoPercentage": 0
                },
            ]
        }
    )

    const onReady = useCallback(async (userInformationId: number) => {
        var currentVideoDurationInSeconds = await getCourseDetails(userInformationId);
        setTimeout(() => {
            if (playerRef.current) {
                playerRef.current.currentTime = currentVideoDurationInSeconds;
            }
        }, 10);
    }, []);

    const runOnce = useRef(false);
    useEffect(() => {
        if (!runOnce.current) {
            const storedProfile = localStorage.getItem("userProfile");
            const userProfile = JSON.parse(storedProfile ?? "");
            window.scrollTo(0, 0)
            setUserInformationId(userProfile.userInformationId);
            onReady(userProfile.userInformationId);
            runOnce.current = true;
        }
    }, [onReady]);


    const getCourseDetails = async (userInformationId: number) => {

        var response = await GetCourseDetails(courseId, userInformationId);
        if (response.statusCode === 200) {
            setCourseLearning(response.data.courses);
            if (response.data.courses.courseVideos) {
                if (response.data.courses.currentVideoId > 0) {
                    var currentRunningCourseVideo = response.data.courses?.courseVideos.find(data => data.courseVideoId === response.data.courses.currentVideoId)
                }
                else {
                    var currentRunningCourseVideo = response.data.courses?.courseVideos[0];
                }
                setSelectedCourse(currentRunningCourseVideo)
                learningUrl(response.data.courses.serverName, currentRunningCourseVideo.courseServerName)
                await LearningCourse(
                    {
                        "userInformationId": userInformationId,
                        "courseId": courseId,
                        "courseVideoId": currentRunningCourseVideo.courseVideoId,
                        "videoTiming": currentRunningCourseVideo.currentVideoDurationInSeconds
                    }, userInformationId
                )
                return currentRunningCourseVideo.currentVideoDurationInSeconds;
            }
        }
    }

    const getCourseDetailsOnUpdate = async (userInformationId: number) => {
        var response = await GetCourseDetails(courseId, userInformationId);
        if (response.statusCode === 200) {  
            setCourseLearning(response.data.courses);
            if (response.data.courses.courseVideos) {
                if (response.data.courses.currentVideoId > 0) {
                    var currentRunningCourseVideo = response.data.courses?.courseVideos.find(data => data.courseVideoId === selectedCourse.courseVideoId)
                    setSelectedCourse(currentRunningCourseVideo)
                }
            }
        }
    }

    const learningUrl = async (serverName: string, courseServerName: string) => {
        var response = await GetLearningUrl({
            "courseName": serverName,
            "courseServerName": courseServerName
        })
        if (response.statusCode === 200) {
            setVideoShow(packageJson.videoApiUrl +
                serverName +
                "/" +
                courseServerName +
                ".mp4?" +
                packageJson.awsAccessKeyId +
                response.data.videoPrivateKey);
        }
    }

    const changeVideo = async (courseVideo: any) => {
        const controller = new AbortController();
        controller.abort();
        if (selectedCourse.courseVideoId != courseVideo.courseVideoId) {
            setSelectedCourse(courseVideo);
            await LearningCourse(
                {
                    "userInformationId": userInformationId,
                    "courseId": courseId,
                    "courseVideoId": courseVideo.courseVideoId,
                    "videoTiming": courseVideo.currentVideoDurationInSeconds
                }, userInformationId
            )
            learningUrl(courseLearning.serverName, courseVideo.courseServerName);
        }
        else {
            if (playerRef.current) {
                if (playerRef.current.paused) {
                    playerRef.current.play();
                    setIsVideoPlay(true);
                } else {
                    playerRef.current.pause();
                    setIsVideoPlay(false);
                }
            }
        }
    }

    const UpdateLearningCourse = async () => {
        
        await LearningCourse(
            {
                "userInformationId": userInformationId,
                "courseId": courseId,
                "courseVideoId": selectedCourse.courseVideoId,
                "videoTiming": playerRef.current?.currentTime
            }, userInformationId
        )
        await getCourseDetailsOnUpdate(userInformationId);
    }

    return (
        <>
            <section>
                <div style={{
                    backgroundColor: "black"
                }}>
                    <div
                        style={{
                            background: "black",
                            padding: "50px 0"
                        }}
                    >
                        <div>
                            <video
                                key={videoShow}
                                ref={playerRef}
                                autoPlay
                                controls
                                controlsList="nodownload"
                                onContextMenu={(e) => e.preventDefault()}
                                className="videoSelect"
                                style={{
                                    position: "relative",
                                    display: "inline-block",
                                    overflow: "hidden",
                                    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                                    background: "black",
                                    padding: "10px 10px"
                                }}
                                onTimeUpdate={() => {
                                    if (playerRef.current) {
                                        const currentTime = Math.floor(playerRef.current.currentTime);
                                        const totalTime = Math.floor(playerRef.current.duration);
                                        if (currentTime === totalTime) {
                                            UpdateLearningCourse();
                                        }
                                        // Trigger the function if the time is a multiple of 60 seconds
                                        if (currentTime % 60 === 0 && currentTime !== 0) {
                                            UpdateLearningCourse();
                                        }
                                    }
                                }}
                            >
                                <source
                                    src={"https://api.growniverse.com/api/Video/courses?courseName="+courseLearning.serverName+"&&courseVideoName="+selectedCourse.courseServerName} // Replace with your .NET backend endpoint
                                    type="video/mp4"
                                />
                                Your browser does not support the video tag.
                            </video>
                            <div style={{ padding: "20px" }}>
                                <h3
                                    style={{
                                        fontSize: "20px",
                                        marginBottom: "10px",
                                        fontWeight: "bold",
                                        color:"white"
                                    }}
                                >
                                    {selectedCourse.courseVideoName || "Video Title"}
                                </h3>

                                {/* Video Metrics */}
                                <div
                                    style={{
                                        fontSize: "14px",
                                        display: "flex",
                                        gap: "15px",
                                        flexWrap: "wrap",
                                        borderBottom: "1px solid #333"
                                    }}
                                >
                                    <p>
                                        <strong>Total Course:</strong> {courseLearning.percentage || 0}%
                                    </p>
                                    <p>
                                        <strong>Chapter:</strong> {selectedCourse.videoPercentage || 0}%
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={{ overflow: "auto", maxHeight: "300px", marginTop: "20px", background: "black", padding: "10px" }}>
                            <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                                {courseLearning.courseVideos.map((course, index) => (
                                    <li
                                        key={course.courseVideoId}
                                        onClick={() => {
                                            changeVideo(course);
                                        }}
                                        style={{
                                            padding: "15px 20px",
                                            marginBottom: "15px",
                                            cursor: "pointer",
                                            backgroundColor:
                                                selectedCourse.courseVideoId === course.courseVideoId
                                                    ? "#007bff"
                                                    : "#f8f9fa",
                                            color:
                                                selectedCourse.courseVideoId === course.courseVideoId
                                                    ? "#fff"
                                                    : "#495057",
                                            border: "1px solid #ddd",
                                            borderRadius: "8px",
                                            fontWeight:
                                                selectedCourse.courseVideoId === course.courseVideoId
                                                    ? "bold"
                                                    : "normal",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                            transition:
                                                "background-color 0.3s ease, color 0.3s ease",
                                        }}
                                    >
                                        <div style={{ display: "flex", gap: "20px", fontSize: "20px", fontWeight: "bold" }}>
                                            <div>
                                                {index + 1}.
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                {course.courseVideoName}
                                                {
                                                    selectedCourse.courseVideoId == course.courseVideoId
                                                        ?
                                                        <>
                                                            {
                                                                isVideoPlay ?
                                                                    <><span>⏸️</span></> : <><span>▶️</span></>
                                                            }
                                                        </>
                                                        :
                                                        ""
                                                }
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Learning;